var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLicensedActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_549_11216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.125H3.75C3.25272 13.125 2.77581 12.9275 2.42417 12.5758C2.07254 12.2242 1.875 11.7473 1.875 11.25V10.625H8.125V11.875C8.125 12.2065 8.2567 12.5245 8.49112 12.7589C8.72554 12.9933 9.04348 13.125 9.375 13.125ZM9.375 13.125C9.70652 13.125 10.0245 12.9933 10.2589 12.7589C10.4933 12.5245 10.625 12.2065 10.625 11.875V3.125C10.625 2.87777 10.6983 2.6361 10.8357 2.43054C10.973 2.22498 11.1682 2.06476 11.3966 1.97015C11.6251 1.87554 11.8764 1.85079 12.1189 1.89902C12.3613 1.94725 12.5841 2.0663 12.7589 2.24112C12.9337 2.41593 13.0528 2.63866 13.101 2.88114C13.1492 3.12361 13.1245 3.37495 13.0298 3.60335C12.9352 3.83176 12.775 4.02699 12.5695 4.16434C12.3639 4.30169 12.1222 4.375 11.875 4.375H10.625M11.875 1.875H5C4.50272 1.875 4.02581 2.07254 3.67417 2.42418C3.32254 2.77581 3.125 3.25272 3.125 3.75V10.625",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.375H8.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 6.875H8.125",
    stroke: "#2D2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_11216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensedActivities);
export default __webpack_public_path__ + "static/media/licensedActivities.4afc8f4b4b6d4f5f2f5e1ce8c8a86cc8.svg";
export { ForwardRef as ReactComponent };